export const USER_DATA = 'USER_DATA';
